<template>
  <section>
    <div class="columns is-centered">
      <div class="column is-6">
        <div class="section no-padding-mobile">
          <div class="container">
            <div class="help-container" id="sent-nda">
              <div id="title">
                <div class="container">
                  <h4 class="title is-4 helvetica" style="margin-bottom: 0;">
                    {{ $t('NF3SNTN1') }}
                    {{ neofintechData.userData.firstName }}
                    {{ neofintechData.userData.lastName }},
                  </h4>
                </div>
              </div>
              <div id="message" class="postScriptum">
                <div class="container">
                  <p>{{ $t('NF3SNTN2') }}</p>
                  <p>{{ $t('NF3SNTN3') }}</p>
                  <p>{{ $t('NF3SNTN4') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import IntroModal from '@/components/on-board/IntroModal.vue'

export default {
  mixins: [],
  components: {
    IntroModal
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  }
}
</script>

<style lang="scss">
#sent-nda.help-container {
  width: 450px;
  min-height: 350px;
  margin: auto;
  background: #ffffffaa;
  border: solid 2px var(--rosa-dark-eco);
  border-radius: 40px;
  overflow: hidden;
  box-shadow: 0 5px 15px #00000044;
  display: grid;
  grid-template-rows: 40%;
  backdrop-filter: blur(3px);
  #message {
    font-size: 20px;
    background: linear-gradient(var(--rosa-eco), var(--rosa-dark-eco));
  }
}
</style>
